export const UsuarioEntity = {
    id: null,
    username: '',
    password: '',
    nombres: '',
    apellidos: '',
    email: '',
    telefono: '',
    docIdentidad: '',
    tipoDocumento: 'DNI',
    profileImage: '',
    profile: {
        id: null,
        name: '',
        permissions: []
    }
};